import { render, staticRenderFns } from "./Actividad.vue?vue&type=template&id=5ee64ae9&scoped=true&lang=pug&"
import script from "./Actividad.vue?vue&type=script&lang=js&"
export * from "./Actividad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee64ae9",
  null
  
)

export default component.exports